import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import ScheduleService from '../../services/scheduleServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk('schedule/list', async ({ start, end, user_id }, thunkAPI) => {
  try {
    const response = await ScheduleService.getList(start, end, user_id);
    return response.data;
  } catch (error) {
    if (error.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListSemester = createAsyncThunk('schedule/getListSemester', async ({ jenjang, cabang }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListSemester(jenjang, cabang);
    // Backend returns { status, message, data }, so we need response.data.data
    return response.data?.data || response.data || {};
  } catch (error) {
    if (error.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListWeekly = createAsyncThunk('schedule/getListWeekly', async ({ jenjang, cabang }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListWeekly(jenjang, cabang);
    return response.data;
  } catch (error) {
    if (error.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListTahunan = createAsyncThunk('schedule/getListTahunan', async ({ jenjang, cabang }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListTahunan(jenjang, cabang);
    
    // Service returns response.data from axios
    // Axios response structure: { data: { status, message, data: {...} } }
    // Service returns: response.data = { status, message, data: {...} }
    // So we need to extract response.data.data
    let result;
    if (response && typeof response === 'object') {
      if ('data' in response && response.data && typeof response.data === 'object' && 'data' in response.data) {
        // response = { data: { status, message, data: {...} } }
        result = response.data.data;
      } else if ('data' in response && response.data) {
        // response = { data: {...} } (already extracted)
        result = response.data;
      } else {
        // response is already the data object
        result = response;
      }
    } else {
      result = {};
    }
    
    return result;
  } catch (error) {
    if (error.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListBulanan = createAsyncThunk('schedule/getListBulanan', async ({ jenjang, cabang }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListBulanan(jenjang, cabang);
    // Backend returns { status, message, data }, so we need response.data.data
    return response.data?.data || response.data || {};
  } catch (error) {
    if (error.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListMingguan = createAsyncThunk('schedule/getListMingguan', async ({ jenjang, cabang }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListMingguan(jenjang, cabang);
    // Backend returns { status, message, data }, so we need response.data.data
    return response.data?.data || response.data || {};
  } catch (error) {
    if (error.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListHarian = createAsyncThunk('schedule/getListHarian', async ({ jenjang, cabang }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListHarian(jenjang, cabang);
    // Backend returns { status, message, data }, so we need response.data.data
    return response.data?.data || response.data || {};
  } catch (error) {
    if (error.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListArchive = createAsyncThunk('schedule/getListArchive', async ({ year, month, user_id }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListArchive(year, month, user_id);

    return response.data;
  } catch (error) {
    if (error.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListDaily = createAsyncThunk('schedule/getListDaily', async ({ date, user_id }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListDaily(date, user_id);

    return response.data;
  } catch (error) {
    if (error.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const readData = createAsyncThunk('schedule/read', async (id, thunkAPI) => {
  try {
    const response = await ScheduleService.read(id);
    return response.data;
  } catch (error) {
    if (error.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const exportAllSchedules = createAsyncThunk('schedule/exportAllSchedules', async (_, thunkAPI) => {
  try {
    await ScheduleService.exportAllSchedules();
  } catch (error) {
    if (error.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = { isLoading: false, list: [], daily: [], data: [], error: [], semester: [], weekly: [], tahunan: {}, bulanan: {}, mingguan: {}, harian: {} };

const scheduleSlice = createSlice({
  name: 'schedule',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListDaily.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListDaily.fulfilled, (state, action) => {
        state.isLoading = false;
        state.daily = action.payload;
      }),
      builder.addCase(getListDaily.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(getListSemester.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getListSemester.fulfilled, (state, action) => {
        state.isLoading = false;
        state.semester = action.payload;
      }),
      builder.addCase(getListSemester.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(getListWeekly.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getListWeekly.fulfilled, (state, action) => {
        state.isLoading = false;
        state.weekly = action.payload;
      }),
      builder.addCase(getListWeekly.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(getListTahunan.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getListTahunan.fulfilled, (state, action) => {
        state.isLoading = false;
        // Ensure we're storing an object, not an array
        if (action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload)) {
          state.tahunan = action.payload;
        } else if (action.payload && Array.isArray(action.payload)) {
          // If it's an array, convert to object format
          state.tahunan = {};
        } else {
          state.tahunan = action.payload || {};
        }
      }),
      builder.addCase(getListTahunan.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(getListBulanan.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getListBulanan.fulfilled, (state, action) => {
        state.isLoading = false;
        state.bulanan = action.payload;
      }),
      builder.addCase(getListBulanan.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(getListMingguan.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getListMingguan.fulfilled, (state, action) => {
        state.isLoading = false;
        state.mingguan = action.payload;
      }),
      builder.addCase(getListMingguan.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(getListHarian.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getListHarian.fulfilled, (state, action) => {
        state.isLoading = false;
        state.harian = action.payload;
      }),
      builder.addCase(getListHarian.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(exportAllSchedules.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(exportAllSchedules.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(exportAllSchedules.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = scheduleSlice;
export default reducer;


